import _ from "lodash";
import {basicContext} from "../../../../utils/contextUtils";
import {changeFieldProperty, setFieldVisibility} from "../../../../../apps/KpModule/actions";

export const module_ = {
    name: 'FollowUp',
    object: 'ReliefFund',
    tKey: 'Suivi dossier',
    category: {path: 'menuTitle_reliefFund', icon: 'heartHandshake'},
    newable: false,
    removable: false,
    viewMap: {
        dt: [
            {path: 'applicationNumber'},
            {path: 'organizationTradingName', tKey: 'tradingName'},
            {path: 'object'},
            {path: 'needsTypes', tKey: 'needs'},
            {path: 'totalRequestedAmountsInEuros', tKey: 'requestedInEuros', tooltip: true},
            {path: 'totalAwardedAmountsInEuros', tooltip: true},
            {path: 'totalTreatedAmountsInEuros', tKey: 'Dont Libéré (€)', tooltip: true},
            {path: 'treatmentRateInEuros', tKey: 'liberationRate'},
            {path: 'totalRequestedAmountsInKilograms', tooltip: true},
            {path: 'totalAwardedAmountsInKilograms', tooltip: true},
            {path: 'totalTreatedAmountsInKilograms', tKey: 'Dont Libéré (kg)', tooltip: true},
            {path: 'treatmentRateInKilograms', tKey: 'liberationRate'},
            {path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle'], translate: true}
        ],
        form: {
            fields: [
                {path: 'object', editable: false},
                {path: 'organizationTradingName', tKey: 'tradingName', editable: false},
                {
                    path: 'needs',
                    type: 'accordion',
                    newable: false,
                    editable: false,
                    disabled: true,
                    viewMap: {
                        dt: [
                            { path: 'natureOfHelp', display: 'nameWithUnit', tKey: 'type'},
                            //{ path: 'totalAmountInEuros' },
                            { path: 'requestedAmountInEuros', tKey: 'requestedInEuros' },
                            { path: 'awardedAmountInEuros', tKey: 'awardedInEuros' },
                            { path: 'treatedAmountInEuros', tKey: 'Dont Libéré (€)'},
                            //{ path: 'totalAmountInKilograms' },
                            { path: 'requestedAmountInKilograms' },
                            { path: 'awardedAmountInKilograms'},
                            { path: 'treatedAmountInKilograms', tKey: 'Dont Libéré (kg)'},
                        ],
                        form: [
                            {
                                path: 'natureOfHelp',
                                tKey: 'type',
                                display: 'nameWithUnit',
                                editable: false,
                                fieldPath: ['id', 'name', 'nameWithUnit', 'eligibleToEmergencyFund', 'facilityRelated', 'unit'],
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const landTypeField = needsField.viewMap.form.fields.find(field => field.path === 'landType')
                                        store.dispatch(setFieldVisibility(landTypeField.id, !!newValue && newValue.facilityRelated))

                                        const requestedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInEuros')
                                        const awardedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'awardedAmountInEuros')
                                        const treatedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'treatedAmountInEuros')

                                        const requestedAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInKilograms')
                                        const awardedAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'awardedAmountInKilograms')
                                        const treatedAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'treatedAmountInKilograms')

                                        store.dispatch(setFieldVisibility(requestedAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(awardedAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(treatedAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))

                                        store.dispatch(setFieldVisibility(requestedAmountInKilogramsField.id, !!newValue && newValue.unit.id === "kilogram"))
                                        store.dispatch(setFieldVisibility(awardedAmountInKilogramsField.id, !!newValue && newValue.unit.id === "kilogram"))
                                        store.dispatch(setFieldVisibility(treatedAmountInKilogramsField.id, !!newValue && newValue.unit.id === "kilogram"))
                                    }
                                }
                            },
                            {
                                path: 'landType', tKey: "Le dossier concerne un lieu", display: 'name', required: true, editable: false, translate: true, sortList: false,
                                hidden: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const landTypeProofField = needsField.viewMap.form.fields.find(field => field.path === 'landTypeProof')

                                        store.dispatch(setFieldVisibility(landTypeProofField.id, !!newValue))
                                        store.dispatch(changeFieldProperty(landTypeProofField.id, 'tKey', `landTypeProof_${newValue?.id}`))
                                    }
                                }
                            },
                            { path: 'totalAmountInEuros', editable: false, hidden: true },
                            { path: 'requestedAmountInEuros', tKey: 'requestedInEuros', editable: false },
                            { path: 'awardedAmountInEuros', tKey: 'awardedInEuros', editable: false },
                            { path: 'treatedAmountInEuros', tKey: 'Dont Libéré (€)', editable: false},
                            { path: 'totalAmountInKilograms', editable: false, hidden: true },
                            { path: 'requestedAmountInKilograms', editable: false },
                            { path: 'awardedAmountInKilograms', editable: false },
                            { path: 'treatedAmountInKilograms', tKey: 'Dont Libéré (kg)', editable: false},
                            { path: 'landTypeProof', required: true, fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', editable: false, hidden: true },
                            { path: 'supportingDocuments', fieldPath: ['id', 'filename', 'user.id', 'date', 'user.name'], type: 'simpleFiles', tKey: "needSupportingDocuments_submission", editable: false},
                        ]
                    }
                },
                {path: 'conversations', tKey: "zone d'échanges"},
                {path: 'buttons', hidden: true},
                {path: 'submitter', hidden: true},
                {path: 'organization', hidden: true}
            ]
        }
    },
    filters: [
        'userHasAuthorization',
        {
            title: 'excludeDraft',
            query: () => {
                return { status: { $ne: 'draft' } }
            }
        },
        {
            title: 'excludeDraftAndIncomplete',
            query: () => {
                return { status: {$nin: ['draft', 'questioned']} }
            }
        },
        {
            title: "Status",
            path: "status",
            tKey: "Statut(s)",
            translate: true,
            type: 'tags',
            default: [{id: 'accepted'}, {id: 'paid'}],
            filters: [
                {
                    name: 'excludeDraftAndIncomplete',
                    match: object => {
                        return !['draft', 'questioned'].includes(object.id)
                    }
                }
            ],
            object: "ReliefFundApplicationStatus",
            display: "name",
            client: true,
            isDefault: false,
            query: function (context) {
                const statusArray = _.get(context, "data.status")

                return statusArray?.length
                    ? {status: {$in: statusArray.map(o => o.id)}}
                    : {}
            }
        },
        {
            path: "authorizedFiles",
            isDefault: false,
            async: true,
            query: async (context, callback) => {
                try {
                    const cUser = await global.app.C.CUser.get({kpUser: new global.ObjectID(context.user.id)}, {
                        ...basicContext(context),
                        fieldPath: [
                            'id',
                            'functions.id',
                            'functions.submissionAuthorization',
                            'functions.studyAuthorization',
                            'functions.decisionAuthorization',
                            'functions.solicitationsManagementAuthorization',
                            'functions.liberationAuthorization',
                            'organization.id',
                            'shelters.id'
                        ]
                    })
                    const userIsAdmin = ['studyAuthorization', 'decisionAuthorization', 'solicitationsManagementAuthorization', 'liberationAuthorization'].some(
                        key => cUser.functions.some(
                            userFunction => !!userFunction[key]
                        )
                    )
                    const userIsSubmitter = cUser.functions.some(
                        userFunction => !!userFunction['submissionAuthorization']
                    )

                    callback(null, userIsAdmin
                        ? {}
                        : userIsSubmitter
                            ? {organization: new global.ObjectID(cUser.organization.id)}
                            : {_id: null}
                    )
                } catch (e) {
                    callback(e)
                }

            }
        },
    ]
}
